import React from 'react';
import { CircleHelp as HelpOutlineIcon } from 'lucide-react';

import styles from './QuestionButton.module.scss';

export type QuestionButtonProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const QuestionButton = (props: QuestionButtonProps) => {
    return (
        <span {...props} aria-label='help' className={styles.questionButton}>
            <HelpOutlineIcon />
        </span>
    );
};

export default QuestionButton;
